import UserPhoto from "./UserPhoto.vue";
import ImageUploader from "./ImageUploader.vue";
import TextField from "./TextField.vue";
import TextAreaField from "./TextAreaField.vue";
import DateField from "./DateField.vue";
import LatestStationReadings from "./LatestStationReadings.vue";
import DisplayProjectTags from "./DisplayProjectTags.vue";
import DoubleHeader from "./DoubleHeader.vue";
import Spinner from "./Spinner.vue";
import FollowPanel from "./FollowPanel.vue";
import StationPhoto from "./StationPhoto.vue";
import ProjectPhoto from "./ProjectPhoto.vue";
import AuthenticatedPhoto from "./AuthenticatedPhoto.vue";

export default {
    UserPhoto,
    ImageUploader,
    TextField,
    TextAreaField,
    DateField,
    LatestStationReadings,
    DisplayProjectTags,
    DoubleHeader,
    Spinner,
    FollowPanel,
    StationPhoto,
    ProjectPhoto,
    AuthenticatedPhoto,
};
